<template>
  <div class="infonews" v-show="personPages.length>1 || companyDatas.length>1">
    <h1 class="bigtitle">会员展示</h1>
    <div style="display:flex">
      <div class="person"  v-show="personPages.length>1">
        <div class="tbanner">
          <img src="/static/img/huiyuan.png" alt="">
          <div class="info-seach">
            <el-input 
              class="inline-input" 
              v-model="inputinfo" 
              placeholder="请输入关键字">
              <button @click="handleSearch" class="seachbtn" slot="suffix"><i
                class="iconfont icon-sousuo" style="font-size:23px;margin-right: 8px;">
              </i>搜索</button>
              </el-input>
            </div>
        </div>
        <div class="personInfo">
          <el-carousel height="235px" :loop="true">
            <el-carousel-item v-for="item in personPages" :key="item">
              <ul>
                <li v-for="(person,index) in personDatas.slice((item-1)*4,(item-1)*4+4)" :key="index" @click="$router.push(`/MemberRlt?name=${person.name}&code=${person.code}&inqType=gr&comeinbysy=1`)">
                  <img :src="`${IP_TEST}/uploads/xlsfile/usepic/${person.picsrc}`" alt="" width="68" height="92"/>
                  <div class="info">
                    <h2>
                      姓名：<span style="color:#4A4A4A">{{ person.name }}</span>
                    </h2>
                    <p>
                      所属行业：<span style="color:#4A4A4A">{{ person.industry }}</span>
                    </p>
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="company" v-show="companyDatas.length>1">
        <div class="tbanner">
          <h2>会员单位</h2>
        </div>
        <div class="companyInfo">
           <vue-seamless-scroll
             :data="companyDatas"
             class="seamless-warp"
             :class-option="optionSetting"
           >
           <ul>
           <li v-for="(company,index) in companyDatas" :key="index"  @click="$router.push(`/MemberRlt?companyname=${company.companyname}&code=${company.code}&inqType=dw&comeinbysy=1`)">
             <h2>
               {{ company.companyname }}
             </h2>
             <p>{{ company.address }}</p>
           </li>
         </ul>
           </vue-seamless-scroll>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IP_TEST,EDIT_LIST } from '@/config'
import {getQYMembers,getGRMembers } from '@/request/get'
export default {
  name: "Editpublish",
  data(){
    return {
      inputinfo:"",
      companyDatas:[],
      personDatas:[],
      personPages:0,
      IP_TEST
    }
  },
  computed: {
    optionSetting() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight:0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  beforeDestroy() {
  },
  created() {
   this.getQYMembers();
   this.getGRMembers();
  },
  mounted(){
    this.$nextTick(()=>{
    })
  },
  methods: {
    handleSearch(){
      this.getGRMembers();
    },
    async getQYMembers(){
      let result = await getQYMembers();
      this.companyDatas = result.data||[];
    },
    async getGRMembers(){
      let result = await getGRMembers(this.inputinfo);
      this.personDatas = result.data||[];
      this.personPages = Math.ceil( this.personDatas.length/4);
    }
  }
};
</script>
<style scoped>
.infonews .bigtitle {
  height: 34px;
  font-size: 36px;
  /* font-family: PingFang SC; */
  font-weight: bold;
  color: #004FB7;
  text-align: center;
  letter-spacing: 5px;
  margin-top: 45px;
  margin-bottom: 30px;
  background-image: url(/static/img/baito.png);
    background-repeat: no-repeat;
    background-position-y: 7px;
}
.person{
  display: inline-block;
}
.person .tbanner{
  width:703px;
  height:91px;
  padding: 25px 16px;
  background-image: url(/static/img/huiyuanbg.png);
}

.info-seach{
  position: relative;
  /* top:142px; */
  /* margin: auto; */
  width: 487px;
  display: inline-block;
  float: right;
  height:57px;
background-color:#fff;
border-radius: 28px;
text-align:center;
line-height: 60px;
}
.info-seach .inline-input{
  width: 477px;
  height: 47px;
  line-height: 54px;

}
.info-seach .inline-input >>>.el-input__inner{
  border-radius: 6px;
  height: 47px;
  line-height: 47px;
  font-size: 16px;
  background-color:#fff;
  color: #000;
  border: 0px;
  border-radius: 25px;
}
.info-seach .inline-input  >>>.el-input__inner{
  padding-left: 20px;
}
.info-seach .inline-input >>> .el-input__prefix{
    height: 47px;
    line-height: 47px;
    font-size: 18px;
    padding: 0 10px 0 10px;
    
}
.info-seach .inline-input >>>.el-input__suffix{
  right: 0px !important;
}
.seachbtn{
  width: 134px;
  height: 51px;;
  background: #0041BE;
  border-radius: 25px;
  color: #fff;
  font-size: 20px;
}
.company{
  display: inline-block;
  width:510px;
  height: 372px;
  margin-left: 56px;
}
.company .tbanner{
  width:510px;
  height:68px;
  background-image: url(/static/img/bitoa.png);
  background-repeat: no-repeat;
  text-align: center;
  font-size: 20px;
  line-height: 68px;
  font-weight: bold;
color: #FFFFFF;
text-shadow: 0px 0px 10px rgba(54,116,239,0.73);
}
.company .tbanner h2{
  background-image: url(/static/img/di.png);
  background-repeat: no-repeat;
  background-position: 128px 34px;
}
.company .companyInfo{
  width:462px;
  height:294px;
  padding:5px 24px;
  overflow:hidden;
  background-image: url(/static/img/danweibg.png)
}
.companyInfo li{
  height:60px;
  margin-top: 32px;
  padding: 1px 0 0 73px;
  background-image: url(/static/img/gognsi.png);
  background-repeat: no-repeat;
}
.companyInfo h2{
  font-size: 18px;
  height: 18px;
  line-height: 18px;
/* font-family: PingFang SC; */
font-weight: bold;
color: #333333;

-webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
.companyInfo p{
  font-size: 14px;
  height: 14px;
  line-height: 14px;
font-weight: bold;
margin-top: 15px;
color: #9C9FA3;
-webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
/deep/ .el-carousel--horizontal{
  overflow: hidden;
}
.seamless-warp{
  height:304px;
}
.personInfo li{
  width: 341px;
height: 94px;
padding: 7px 10px 7px 10px;
background: #F3F3F3;
display: inline-block;
margin-top: 9px;
}
.personInfo li:nth-child(2n){
  margin-left:10px;
}
.personInfo li .info{
  width:226px;
  display: inline-block;
  margin-left: 17px;
  padding: 20px 0;
}
.personInfo li h2{
  width: 226px;
  font-size: 16px;
/* font-family: PingFang SC; */
font-weight: 500;
-webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}
.personInfo li p{
  width: 226px;
  font-size: 16px;
  margin-top:20px ;
/* font-family: PingFang SC; */
font-weight: 500;
-webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}
.personInfo ul{
  display: flex;
  flex-flow: row wrap;
}
</style>
